<script setup lang="ts">
import AppShell from '@/widgets/app-shell/AppShell.vue';
import SimulationNoticeDialog from '@/shared/simulation/SimulationNoticeDialog.vue';
</script>

<template>
  <AppShell />
  <SimulationNoticeDialog />
</template>
